import React from "react";
import { Avatar } from "@mui/material";
import GroupsIcon from "@mui/icons-material/Groups";

import { getInitials } from "../../utils/getInitials";
import { getAvatarColor } from "../../utils/avatarColor";

const ChatAvatar = ({ name, image, isGroupChat = false, size = 40 }) => {
  if (isGroupChat) {
    return (
      <Avatar sx={{ width: size, height: size, bgcolor: "#64748B" }}>
        <GroupsIcon fontSize="small" />
      </Avatar>
    );
  }

  return (
    <Avatar
      src={image || undefined}
      sx={{
        width: size,
        height: size,
        bgcolor: getAvatarColor(name),
        fontSize: size * 0.375,
        fontWeight: 700,
      }}
    >
      {getInitials(name)}
    </Avatar>
  );
};

export default ChatAvatar;
